
  <template class="is-fullheight">
    <div class="is-fullheight">
      <div id="bg_login">
        <img src="../assets/bg.jpg" alt="">
      </div>
      <div class="is-fullheight">
        <div class="login-block">
          <div class="login-background"></div>
          <h1 class="title">Welcome to Expeditr <img src="../assets/logo.svg" class="logo" alt=""></h1>
          <div class="alert alert-danger" v-if="error">
            <p>{{ error }}</p>
          </div>
          <a id="login-button" class="button is-primary is-large" href="/oauth2/login">
            <span class="icon is-small">
              <i class="fa fa-windows"></i>
            </span>
            <span>Login using Canopy SSO</span>
          </a>
        </div>
      </div>
    </div>
  </template>

  <script>
  export default {
    data () {
      return {
        // We need to initialize the component with any
        // properties that will be used in it
        credentials: {
          username: '',
          password: ''
        },
        error: ''
      }
    }
  }
  </script>

  <style scoped>
    #bg_login {
      position: fixed;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      z-index: -1000;
    }
    #bg_login img {
      opacity: 0.5;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      min-width: 50%;
      min-height: 50%;
    }
    #login-button {
      margin-bottom: 10px;
      margin-left: 10px;
      margin-right: 10px;
    }
    h1.title {
      margin: 15px;
    }
    .login-background {
      position: absolute;
      padding: 10px;
      width: 100%;
      height: 100%;
      background: white;
      opacity: 0.5;
      border-radius: 10px;
      z-index: -500;
    }
    img.logo {
      max-width: 75px;
      max-height: 75px;
    }
    .is-fullheight {
      position: relative;
      height: 100%;
    }
    .login-block {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  </style>
